import { SuccessResponse } from '../../auth.types'

export interface LogoutRequest {
  refresh_token: string
}

export type LogoutResponse = SuccessResponse<{
  message: string
}>
